import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchPosts } from '../services/api';

function formatDate(s) {
  if (!s) return '';
  const d = new Date(s);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogList() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await fetchPosts();
        setItems(data);
      } catch (e) {
        setErr(e.message || 'Error');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const filtered = items.filter(p =>
    (p.title || '').toLowerCase().includes(q.toLowerCase()) ||
    (p.excerpt || '').toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="container mx-auto px-4 py-10">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-semibold text-slate-900">Blog</h1>
          <p className="text-slate-600">Insights on metabolic health, gallbladder and hernia surgery.</p>
        </div>
        <div className="w-full sm:w-80">
          <input
            className="w-full rounded-lg border border-slate-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder="Search posts…"
            value={q}
            onChange={e => setQ(e.target.value)}
          />
        </div>
      </div>

      {loading && <p>Loading posts…</p>}
      {err && <p className="text-red-600">{err}</p>}

      <div className="grid gap-6 md:grid-cols-2">
        {filtered.map(post => (
          <article key={post.id} className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden hover:shadow-md transition">
            {post.featured_image && (
              <Link to={`/blog/${post.slug}`}>
                <img
                  src={post.featured_image}
                  alt={post.title}
                  className="w-full h-48 object-cover"
                  loading="lazy"
                />
              </Link>
            )}
            <div className="p-5">
              <time className="text-xs text-slate-500">{formatDate(post.published_at)}</time>
              <h2 className="mt-2 text-xl font-semibold">
                <Link to={`/blog/${post.slug}`} className="hover:text-indigo-600">{post.title}</Link>
              </h2>
              {post.excerpt && <p className="mt-2 text-slate-700 line-clamp-3">{post.excerpt}</p>}
              <div className="mt-4">
                <Link to={`/blog/${post.slug}`} className="text-indigo-600 hover:text-indigo-800 font-medium">
                  Read more →
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>

      {!loading && !err && filtered.length === 0 && (
        <p className="text-slate-600 mt-8">No posts found.</p>
      )}
    </div>
  );
}
